import React, { Dispatch, SetStateAction } from 'react'

import { FormikValues } from 'formik'

import { PartyOption } from './'
import { SelectField } from '@/components/FormikInputs'
import { Step } from '@/components/Stepper'
import { ProfileTypes } from '@/constants/applicationProfile'

interface CommonStepsProps {
  values: FormikValues
  partyOptions: PartyOption[]
  setSelectedType: Dispatch<SetStateAction<string>>
  setValues: Dispatch<SetStateAction<FormikValues>>
}

/**
 * Returns the first two steps for adding a contact
 * 1. selects the mode for the 3rd step, which either manual user input or select from directory
 * 2. selects the contact type to be added
 */
export const CommonSteps = ({
  values,
  partyOptions,
  setSelectedType,
  setValues,
}: CommonStepsProps): Step[] => {
  const contactTypeOptions = [
    ...partyOptions,
    { value: ProfileTypes.CO_OWNER, label: 'Co-Owner', category: null, predefined: false },
    { value: ProfileTypes.NOO, label: 'NOO', category: null, predefined: false },
  ]

  return [
    {
      title: 'Select Method',
      content: () => (
        <SelectField
          style='default'
          name='currentMode'
          options={[
            { value: 'directory', label: 'Add From Directory' },
            { value: 'new', label: 'Add New' },
          ]}
          extraClasses='w-full h-full flex items-center justify-center'
          showError={false}
        />
      ),
      buttonLabel: 'Next',
      disabledButton: !values.currentMode,
    },
    {
      title: 'Contact Type',
      content: () => (
        <SelectField
          style='default'
          name='contact_type'
          options={
            values.currentMode == 'directory'
              ? contactTypeOptions.filter((it) => it.category === 'company')
              : contactTypeOptions.filter((it) => !it.predefined)
          }
          onChange={(e) => {
            // Changes the contact type and also resets the form data in the 3rd step
            const contact_type = e.target.value
            setSelectedType(contact_type)
            setValues({
              contact_type,
              currentMode: values.currentMode,
            })
          }}
          showError={false}
          extraClasses='w-full h-full flex items-center justify-center'
        />
      ),
      buttonLabel: 'Next',
      disabledButton: !values.contact_type,
      disabledStep: !values.currentMode,
    },
  ]
}
